/* ==========================================================================
   BLOG CONFIGURATEUR — Multi-tag filter (vanilla JS, no jQuery/Select2)
   ========================================================================== */
(function () {
  'use strict';

  var filter = document.querySelector('[data-blog-tag-filter]');
  if (!filter) return;

  var blogUrl = filter.dataset.blogUrl;
  var toggle = filter.querySelector('[data-filter-toggle]');
  var dropdown = filter.querySelector('[data-filter-dropdown]');
  var checkboxes = filter.querySelectorAll('[data-tag-value]');
  var chipsContainer = filter.querySelector('[data-filter-chips]');
  var clearBtn = filter.querySelector('[data-filter-clear]');

  // Toggle dropdown
  if (toggle) {
    toggle.addEventListener('click', function () {
      var isOpen = dropdown.hidden;
      dropdown.hidden = !isOpen;
      toggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  // Close dropdown when clicking outside
  document.addEventListener('click', function (e) {
    if (!filter.contains(e.target) && dropdown && !dropdown.hidden) {
      dropdown.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
  });

  // Handle checkbox changes
  checkboxes.forEach(function (cb) {
    cb.addEventListener('change', function () {
      navigateToTags();
    });
  });

  // Handle chip removal
  if (chipsContainer) {
    chipsContainer.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-chip-tag]');
      if (!chip) return;

      var tagValue = chip.dataset.chipTag;
      // Uncheck the corresponding checkbox
      checkboxes.forEach(function (cb) {
        if (cb.dataset.tagValue === tagValue) {
          cb.checked = false;
        }
      });
      navigateToTags();
    });
  }

  // Clear all filters
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      window.location.href = blogUrl;
    });
  }

  function navigateToTags() {
    var selected = [];
    checkboxes.forEach(function (cb) {
      if (cb.checked) {
        selected.push(handleize(cb.dataset.tagValue));
      }
    });

    if (selected.length === 0) {
      window.location.href = blogUrl;
    } else {
      window.location.href = blogUrl + '/tagged/' + selected.join('+');
    }
  }

  function handleize(str) {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }
})();
